(() => {
  'use strict';
  if (window.__plRelatedProductsV2) return;
  window.__plRelatedProductsV2 = true;
  const rootSelector = '#rebuy-widget-316848';
  const cache = new Map(), states = new WeakMap();
  const rootPath = window.Shopify?.routes?.root || '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(value / 100);
  function productData(url) {
    const path = url.pathname.replace(/\/$/, '') + '.js';
    if (!cache.has(path)) cache.set(path, fetch(path, {credentials:'same-origin'})
      .then(r => { if (!r.ok) throw new Error('Product data unavailable'); return r.json(); })
      .catch(e => { cache.delete(path); throw e; }));
    return cache.get(path);
  }
  function node(tag, cls, text) {
    const el = document.createElement(tag); el.className = cls;
    if (text != null) el.textContent = text; return el;
  }
  function frequency(plan) {
    const option = plan.options?.find(o => o.name === 'Order Frequency and Unit');
    const match = option?.value?.match(/^(\d+)-(day|week|month|year)/i);
    return match ? Number(match[1]) * ({day:1,week:7,month:30,year:365}[match[2].toLowerCase()]) : Infinity;
  }
  function planQuantity(plan) {
    return Math.max(1, Number(plan?.options?.find(o => o.name === 'Product Quantity')?.value) || 1);
  }
  function render(card, state) {
    const {product,variant} = state;
    const info = card.querySelector('.rebuy-product-info');
    if (!info) return;
    const plans = new Map((product.selling_plan_groups || []).flatMap(g=>g.selling_plans || []).map(p=>[String(p.id),p]));
    const allocations = (variant.selling_plan_allocations || []).filter(a=>plans.has(String(a.selling_plan_id)))
      .sort((a,b)=>frequency(plans.get(String(a.selling_plan_id)))-frequency(plans.get(String(b.selling_plan_id))));
    card.querySelectorAll('.pl-related-purchase,.pl-related-price,.pl-related-error').forEach(e=>e.remove());
    card.classList.toggle('pl-related-has-plans', allocations.length > 0);
    card.classList.add('pl-related-ready');
    state.allocations = allocations; state.plans = plans;
    const required = product.requires_selling_plan || variant.requires_selling_plan;
    if (!allocations.length && required) return;
    state.mode = required ? 'autoship' : 'onetime';
    state.selectedPlan = String(allocations[0]?.selling_plan_id || '');
    const price = node('div','pl-related-price');
    const main = node('strong','pl-related-price-main');
    const compare = node('s','pl-related-price-compare');
    const save = node('span','pl-related-save');
    price.append(main,compare,save);
    info.append(price);
    const controls = node('div','pl-related-purchase');
    const group = node('div','pl-related-toggle'); group.setAttribute('role','group');
    group.setAttribute('aria-label','Purchase option for ' + product.title);
    const once = node('button','pl-related-toggle-btn','One-time');
    const autoship = node('button','pl-related-toggle-btn','Autoship');
    once.type=autoship.type='button'; once.disabled=!!required;
    group.append(once,autoship);
    const delivery = node('label','pl-related-delivery');
    delivery.append(node('span','pl-related-delivery-label','Deliver'));
    const select=node('select','pl-related-frequency');
    select.setAttribute('aria-label','Delivery frequency for ' + product.title);
    allocations.forEach(a=>{
      const plan=plans.get(String(a.selling_plan_id));
      const option=document.createElement('option');
      option.value=String(plan.id); option.textContent=plan.name;
      select.append(option);
    });
    delivery.append(select);
    function update() {
      const sub=state.mode==='autoship';
      const allocation=allocations.find(a=>String(a.selling_plan_id)===state.selectedPlan);
      const amount=sub && allocation ? allocation.price : variant.price;
      main.textContent=money(amount);
      compare.textContent=variant.compare_at_price>amount ? money(variant.compare_at_price) : '';
      compare.hidden=!compare.textContent;
      const pct=variant.price > 0 ? Math.round((variant.price-amount)/variant.price*100) : 0;
      save.textContent=pct>0 ? 'Save '+pct+'%' : ''; save.hidden=!(sub && pct>0);
      once.setAttribute('aria-pressed',String(!sub)); autoship.setAttribute('aria-pressed',String(sub));
      delivery.hidden=!sub;
      card.dataset.plRelatedMode=state.mode;
      const qty=sub ? planQuantity(plans.get(state.selectedPlan)) : 1;
      state.quantity=qty;
      let note=controls.querySelector('.pl-related-quantity-note');
      if(!note){note=node('div','pl-related-quantity-note'); controls.append(note);}
      note.textContent=qty>1 ? 'Quantity: '+qty+' · '+money(amount*qty)+' per order' : '';
      note.hidden=qty<=1;
    }
    once.addEventListener('click',()=>{state.mode='onetime';update();});
    autoship.addEventListener('click',()=>{state.mode='autoship';update();});
    select.addEventListener('change',()=>{state.selectedPlan=select.value;update();});
    if(allocations.length){controls.append(group,delivery);info.insertBefore(controls,price);}
    state.update=update; update();
  }
  async function enhance(card) {
    const link=card.querySelector('.rebuy-product-title-link');
    if(!link)return;
    const url=new URL(link.href,location.origin);
    const variantId=url.searchParams.get('variant');
    const key=url.pathname+'?variant='+variantId;
    let state=states.get(card);
    if(state?.key===key && (state.loading || card.querySelector('.pl-related-price')))return;
    state={key,loading:true};states.set(card,state);
    try {
      const product=await productData(url);
      if(states.get(card)!==state || !card.isConnected)return;
      const variant=product.variants.find(v=>String(v.id)===variantId) || product.variants.find(v=>v.available);
      if(!variant){state.loading=false;return;}
      Object.assign(state,{product,variant,loading:false});
      render(card,state);
    } catch(e) { state.loading=false; }
  }
  async function add(event) {
    const button=event.target.closest('.rebuy-product-actions .rebuy-button');
    if(!button)return;
    const card=button.closest('.rebuy-product-block'),state=states.get(card);
    if(!state?.variant || !card.querySelector('.pl-related-price'))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(state.busy || !state.variant.available)return;
    const sub=state.mode==='autoship';
    if(sub && !state.allocations.some(a=>String(a.selling_plan_id)===state.selectedPlan))return;
    state.busy=true;button.disabled=true;
    const error=card.querySelector('.pl-related-error');if(error)error.remove();
    const item={id:state.variant.id,quantity:state.quantity||1,
      properties:{_source:'Rebuy',_widget_id:'316848'}};
    if(sub)item.selling_plan=Number(state.selectedPlan);
    try{
      const response=await fetch(rootPath+'cart/add.js',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description || result.message || 'Unable to add this item.');
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    }catch(e){
      const message=node('div','pl-related-error',e.message);
      message.setAttribute('role','alert');card.querySelector('.rebuy-product-actions').append(message);
    }finally{state.busy=false;button.disabled=false;}
  }
  const mounted = new WeakMap();
  const style = document.createElement('style');
  style.textContent = `
    #rebuy-widget-316848 [data-pl-native-carousel] {
      display: flex !important; flex-wrap: nowrap !important;
      overflow-x: auto !important; overflow-y: hidden !important;
      scroll-snap-type: none !important; scroll-behavior: auto;
      transform: none !important; gap: 0 !important;
      overscroll-behavior-x: contain; -webkit-overflow-scrolling: touch;
      scrollbar-width: none; cursor: grab; touch-action: auto;
      width: 100% !important; max-width: 100%; box-sizing: border-box;
    }
    #rebuy-widget-316848 [data-pl-native-carousel]::-webkit-scrollbar { display: none; }
    #rebuy-widget-316848 [data-pl-native-carousel] > .rebuy-product-block {
      flex: 0 0 calc(100% / var(--pl-native-columns, 5)) !important;
      width: calc(100% / var(--pl-native-columns, 5)) !important;
      max-width: none !important; box-sizing: border-box !important;
    }
    #rebuy-widget-316848 [data-pl-native-carousel] img { -webkit-user-drag: none; user-select: none; }
    #rebuy-widget-316848 [data-pl-native-carousel].pl-is-dragging { cursor: grabbing; user-select: none; }
    #rebuy-widget-316848 [data-pl-native-carousel] :is(button,select,input) { cursor: auto; }
    #rebuy-widget-316848 .pl-native-nav {
      position: absolute !important; top: var(--pl-related-arrow-top, 20px) !important;
      right: 10px !important; transform: translateY(-50%);
      display: flex !important; gap: 5px !important; z-index: 2;
    }
    #rebuy-widget-316848 .pl-native-nav button {
      position: static !important; transform: none !important;
      display: flex !important; align-items: center; justify-content: center;
      width: 30px !important; height: 30px !important; min-width: 30px;
      padding: 0 !important; border: 0 !important; border-radius: 50% !important;
      background: rgba(80,80,80,.1) !important; color: #000 !important;
      backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
      box-shadow: none !important; opacity: 1 !important;
      transition: background-color .3s, color .3s;
    }
    #rebuy-widget-316848 .pl-native-nav button::before { display: none !important; }
    #rebuy-widget-316848 .pl-native-nav button svg {
      display: block !important; width: 16px !important; height: 16px !important;
      fill: none !important; stroke: currentColor;
    }
    #rebuy-widget-316848 .pl-native-nav button:hover:not(:disabled) {
      background: #000 !important; color: #fff !important;
    }
    #rebuy-widget-316848 .pl-native-nav button:disabled { opacity: .5 !important; }
    #rebuy-widget-316848 .pl-native-nav button:focus-visible {
      outline: 2px solid #2f27ce; outline-offset: 3px;
    }
  `;

  function setupNative(root) {
    const container = root.querySelector('.rebuy-product-grid');
    const grid = container?.querySelector('.splide__list') || container;
    const title = root.querySelector('.primary-title');
    const content = root.querySelector('.rebuy-widget-content');
    const previous = mounted.get(root);
    if (previous && previous.grid === grid && previous.title === title && previous.content === content) return;
    if (previous) { previous.cleanup(); mounted.delete(root); }
    if (!grid || !title || !content || /(?:^|\s)(?:large|medium|small)-carousel(?:\s|$)/.test(container.className)) return;
    if (!style.isConnected) document.head.append(style);
    const controller = new AbortController();
    const signal = controller.signal;
    function listen(target, type, handler, options = {}) {
      target.addEventListener(type, handler, { ...(typeof options === 'boolean' ? { capture: options } : options), signal });
    }
    grid.setAttribute('data-pl-native-carousel', '');
    grid.setAttribute('role', 'list');
    grid.setAttribute('tabindex', '0');
    grid.setAttribute('aria-label', 'Recommended products. Scroll horizontally to browse.');
    content.style.position = 'relative';
    const nav = document.createElement('div');
    nav.className = 'pl-native-nav';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', 'Recommendation navigation');
    function button(label, next) {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"' +
        (next ? ' style="transform:rotate(180deg)"' : '') +
        '><path d="M14.668 7.96094L1.33464 7.96094M6.1836 12.667L1.33511 7.96111L6.18359 3.25523" stroke="currentColor" fill="none"/></svg>';
      return b;
    }
    const prev = button('Previous products', false);
    const next = button('Next products', true);
    nav.append(prev, next); content.append(nav);
    function move(direction) {
      const card = grid.querySelector('.rebuy-product-block');
      const width = card?.getBoundingClientRect().width || grid.clientWidth;
      grid.scrollBy({left: direction * width,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    listen(prev, 'click', () => move(-1));
    listen(next, 'click', () => move(1));
    function update() {
      prev.disabled = grid.scrollLeft <= 1;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
    }
    function layout() {
      const size = window.innerWidth <= 480 ? 'small' : window.innerWidth <= 768 ? 'medium' : 'large';
      const match = container.className.match(new RegExp(size + '-columns-(\\d+)'));
      const columns = match ? match[1] : size === 'large' ? '5' : '2';
      if (grid.style.getPropertyValue('--pl-native-columns') !== columns) grid.style.setProperty('--pl-native-columns', columns);
      const t = title.getBoundingClientRect(), c = content.getBoundingClientRect();
      const top = (t.top - c.top + t.height / 2) + 'px';
      if (root.style.getPropertyValue('--pl-related-arrow-top') !== top) root.style.setProperty('--pl-related-arrow-top', top);
      update();
    }
    listen(grid, 'scroll', update, {passive:true});
    // Apply horizontal trackpad movement directly, without advancing slides.
    listen(grid, 'wheel', event => {
      if (event.ctrlKey || event.target.closest('input,select,textarea')) return;
      const dx = event.shiftKey && Math.abs(event.deltaX) < Math.abs(event.deltaY)
        ? event.deltaY : event.deltaX;
      if (!dx || (!event.shiftKey && Math.abs(dx) <= Math.abs(event.deltaY))) return;
      const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? grid.clientWidth : 1;
      const before = grid.scrollLeft;
      grid.scrollLeft += dx * scale;
      if (grid.scrollLeft !== before) {
        event.preventDefault();
        event.stopImmediatePropagation();
        update();
      }
    }, { passive: false, capture: true });

    const resize = new ResizeObserver(layout);
    resize.observe(title); resize.observe(grid);
    listen(window, 'resize', layout, {passive:true});
    // Trackpads and touch use the browser's native scroll position. No wheel interception.
    let dragging = false, startX = 0, startY = 0, startScroll = 0, didDrag = false, pointerId = null, releaseTimer;
    listen(grid, 'pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 ||
          event.target.closest('button,input,select,textarea,label')) return;
      startX = event.clientX; startY = event.clientY; startScroll = grid.scrollLeft;
      dragging = true; didDrag = false; pointerId = event.pointerId;
    });
    listen(window, 'pointermove', event => {
      if (!dragging || event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      if (!didDrag && (Math.abs(dx) < 5 || Math.abs(dx) <= Math.abs(event.clientY - startY))) return;
      didDrag = true;
      grid.classList.add('pl-is-dragging');
      grid.scrollLeft = startScroll - dx;
      event.preventDefault();
    });
    function release() {
      dragging = false; grid.classList.remove('pl-is-dragging');
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(() => {didDrag = false;}, 0);
    }
    listen(window, 'pointerup', release);
    listen(window, 'pointercancel', release);
    listen(window, 'blur', release);
    listen(grid, 'dragstart', event => event.preventDefault());
    listen(grid, 'click', event => {
      if (didDrag) {event.preventDefault(); event.stopImmediatePropagation();}
    }, true);
    listen(grid, 'keydown', event => {
      if (event.target !== grid || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
    const childrenObserver = new MutationObserver(() => {
      grid.querySelectorAll('.rebuy-product-block').forEach(card => card.setAttribute('role','listitem'));
      update();
    });
    childrenObserver.observe(grid,{childList:true});
    grid.querySelectorAll('.rebuy-product-block').forEach(card => card.setAttribute('role','listitem'));
    mounted.set(root, { grid, title, content, cleanup() {
      controller.abort(); resize.disconnect(); childrenObserver.disconnect();
      clearTimeout(releaseTimer); nav.remove(); grid.classList.remove('pl-is-dragging');
    }});
    layout();
  }

  const observed = new WeakSet();
  function scan() {
    document.querySelectorAll(rootSelector).forEach(root => {
      root.querySelectorAll('.rebuy-product-block').forEach(enhance);
      setupNative(root);
      if (observed.has(root)) return;
      observed.add(root);
      root.addEventListener('click', add, true);
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          if (!root.isConnected) return;
          root.querySelectorAll('.rebuy-product-block').forEach(enhance);
          setupNative(root);
        });
      }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
    });
  }
  function init() {
    scan();
    // Observe the page only while waiting for the first widget mount.
    // Later updates are handled inside the widget and by Rebuy lifecycle events.
    if (document.querySelector(rootSelector)) return;
    let queued = false;
    const boot = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (!document.querySelector(rootSelector)) return;
        boot.disconnect(); clearTimeout(timeout); scan();
      });
    });
    const timeout = setTimeout(() => boot.disconnect(), 20000);
    boot.observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('rebuy.ready', scan);
  document.addEventListener('rebuy.productsChange', scan);
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
